import { ReactElement } from 'react'
import { Route, Routes } from 'react-router-dom'

import {
  PasswordRecoveryDifficulty,
  OtpCode,
  ResetPassword,
  PasswordRecoverySuccess,
  Cellphone,
} from '~containers'

const PasswordRecovery = (): ReactElement => {
  return (
    <Routes>
      <Route index element={<Cellphone />} />
      <Route path="sucesso" element={<PasswordRecoverySuccess />} />
      <Route path="validar" element={<OtpCode />} />
      <Route path="redefinir" element={<ResetPassword />} />
      <Route path="dificuldade" element={<PasswordRecoveryDifficulty />} />
    </Routes>
  )
}

export default PasswordRecovery
